// Skype Notification types:
// CALL: Notification on incoming call
// IM: Notification on unread message
// SUMMARY: Notification on summary of unread messages (generally treated the same as IM)
export const CALL_NOTIFICATION_TYPE = 'Calling';
export const IM_NOTIFICATION_TYPE = 'UnreadMessage';
export const SUMMARY_NOTIFICATION_TYPE = 'Summary';
